import React from 'react';
import PuzzleInputWithActions from '../input/PuzzleInputWithActions';
import { PureComponent } from '../../../../dispatcher/modules';
import { PUZZLE_FIND_AND_REPLACE_PROPS } from './Types';
import HBox from '../../../layout/container/h_box/HBox';
import { PUZZLE_FIELD_STATE } from '../Types';
import * as _ from 'lodash';

/**
 * This component is designed for scenarios where you need to search a query within a text file or data.
 * It includes a loading indicator to show progress while the data is being processed, and it displays the results of the search,
 * along with the total number of matches for the given query.
 * Additionally, the component provides several useful callbacks for handling various actions during the search process.
 */
class PuzzleFindAndReplace extends PureComponent<PUZZLE_FIND_AND_REPLACE_PROPS, PUZZLE_FIELD_STATE> {
  render() {
    const {
      disabled,
      openDialogAction,
      loading,
      counter,
      nextAction,
      previousAction,
      searchAction,
      clearAction,
      value
    } = this.props;

    let afterActions = [];

    if (value) {
      if (loading) {
        afterActions.push(
          <HBox
            htmlTag={'span'}
            dataCy={'spinner'}
            className="tp-input-spinner"
          />);
      }
      if (!loading) {
        afterActions.push(
          <HBox dataCy={'counter'}>
            {counter?.found || 0}
            /
            {counter?.total || 0}
          </HBox>
        );
      }
      afterActions = afterActions.concat([{
        withTooltip: true,
        iconClass: 'tp-icon tp-arrow-chevron-left',
        fillMode: 'flat',
        titleText: this.translate('previous'),
        fieldSize: 'sm',
        disabled: disabled,
        onClick: previousAction,
        'data-cy': 'previousAction'
      }, {
        withTooltip: true,
        iconClass: 'tp-icon tp-arrow-chevron-right',
        fillMode: 'flat',
        titleText: this.translate('next'),
        fieldSize: 'sm',
        disabled: disabled,
        onClick: nextAction,
        'data-cy': 'nextAction'
      }, {
        withTooltip: true,
        iconClass: 'tp-icon tp-x',
        fillMode: 'flat',
        titleText: this.translate('clear'),
        fieldSize: 'sm',
        disabled: disabled,
        onClick: clearAction,
        'data-cy': 'clearAction'
      }]);
    }

    afterActions.push({
      withTooltip: true,
      iconClass: 'tp-icon tp-search',
      themeColor: 'primary',
      titleText: this.translate('search'),
      size: 'small',
      disabled: disabled || !value,
      onClick: searchAction,
      'data-cy': 'searchAction'
    });

    const findAndReplaceProps = _.omit(this.props, [
      'openDialogAction',
      'loading',
      'counter',
      'nextAction',
      'previousAction',
      'searchAction',
      'clearAction'
    ]);

    const findAndReplaceInputProps = _.omit(findAndReplaceProps, [
      'label',
      'labelClassName'
    ]);

    return (
      <PuzzleInputWithActions
        actionsBefore={[{
          fillMode: 'flat' as const,
          iconClass: 'tp-icon tp-manage-filters',
          withTooltip: true,
          titleText: this.translate('openDialog'),
          size: 'small',
          disabled: disabled,
          onClick: openDialogAction,
          'data-cy': 'openDialogAction'
        }]}
        actionsAfter={afterActions}
        inputProps={{ ...findAndReplaceInputProps }}
        {...findAndReplaceProps}
      />
    );
  }
}

export default PuzzleFindAndReplace;
